<template>
	<div class="maintenance">
		<div class="maintenance-container">
			<div class="maintenance-content">
				<div class="form-content">
					<el-form ref="maintenanceForm" :model="maintenanceForm" :rules="rules" :disabled="!isSetting" label-width="200px">
						<div class="section-header">
							<h4>企业技术负责人</h4>
							<el-button v-if="isSetting" type="primary" @click="handleAddPerson">
								选择人员
							</el-button>
						</div>

						<div class="form-row">
							<el-form-item label="姓名：" prop="personName" class="form-item">
								<el-input v-model="maintenanceForm.personName" placeholder="" readonly></el-input>
							</el-form-item>
							<el-form-item label="身份证号：" prop="idCard" class="form-item">
								<el-input v-model="maintenanceForm.idCard" placeholder="" readonly></el-input>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item label="证书类型：" prop="certificateName" class="form-item">
								<el-input v-model="maintenanceForm.certificateName" placeholder="" readonly></el-input>
							</el-form-item>
							<el-form-item label="发证编号：" prop="certificateCode" class="form-item">
								<el-input v-model="maintenanceForm.certificateCode" placeholder="" readonly></el-input>
							</el-form-item>
						</div>
						<div class="form-row">
							<el-form-item label="证书有效期：" prop="validityTime" class="form-item">
								<el-input v-model="maintenanceForm.validityTime" placeholder="" readonly></el-input>
							</el-form-item>
							<el-form-item label="从事工程建设工作年限：" prop="csnx" class="form-item">
								<el-input v-model="maintenanceForm.csnx" v-positiveInteger placeholder=""></el-input>
							</el-form-item>
						</div>

						<div class="section-header">
							<h4>管理体系、制度及工程设备</h4>
						</div>

						<div class="form-row">
							<el-form-item
								label="是否具备较完善的组织结构和质量管理体系及技术与档案管理制度："
								prop="isGlzd"
								label-width="505px"
								class="form-item"
							>
								<el-radio-group v-model="maintenanceForm.isGlzd">
									<el-radio label="1">是</el-radio>
									<el-radio label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>

						<div class="form-row">
							<el-form-item label="是否具备工程试验检测试设备：" prop="isGcsysb" label-width="250px" class="form-item">
								<el-radio-group v-model="maintenanceForm.isGcsysb">
									<el-radio label="1">是</el-radio>
									<el-radio label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
					</el-form>
				</div>
			</div>

			<div v-if="isSetting && !isDiagnostic" class="maintenance-footer">
				<el-button :loading="saveLoading" type="primary" @click="handleSaveEngineeringMaintenanceInfo">保 存</el-button>
			</div>

			<!-- 未绑定企业遮罩层 -->
			<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-else-if="isNormalVip"></nonbind-vip>
		</div>

		<!-- 企业人员(注册监理工程师人员列表) -->
		<jr-dialog :visible.sync="staffLibraryVisible" title="企业人员" width="70%" top="100px" :append-to-body="true">
			<template v-if="staffLibraryVisible" slot="content">
				<supervisor-library ref="supervisorLibrary"></supervisor-library>
			</template>
			<template slot="footer">
				<el-button @click="handleCloseStaff">取 消</el-button>
				<el-button type="primary" @click="handleSaveStaffInfo">确 定</el-button>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import SupervisorLibrary from '../components/supervisorLibrary'
	import NonbindVip from '@/components/NonBind/nonbindVip'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import { saveGcjlMaintenanceInfo, queryGcjlMaterialRecord } from '@/api/certTreasure/materialRecord'
	import { mapGetters } from 'vuex'

	// 工程监理资质材料维护
	export default {
		name: 'EngineeringSupervisionMaintenance',
		components: {
			JrDialog,
			SupervisorLibrary,
			NonbindVip,
			NonbindEnterprise
		},
		props: {
			// 是否开启配置
			isSetting: {
				type: Boolean,
				default: false
			},
			// 是否是诊断提交材料处打开，主要用于控制“保存“是否显示
			isDiagnostic: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 诊断记录id
				diagnosisRecordId: '',
				maintenanceTypes: [
					{ name: '企业技术负责人', type: '1' },
					{ name: '工程设备', type: '1' }
				],
				// 当前选中的类型索引
				activeTypeIndex: 0,

				// 工程监理资质材料人员信息表单
				maintenanceForm: {
					id: '',
					personId: '',
					personName: '',
					certType: '',
					sex: '',
					idCard: '',
					registerType: '',
					registerSubType: '',
					certificateName: '',
					certificateGrade: '',
					certificateCode: '',
					certificateType: '',
					registerCode: '',
					registerUnitName: '',
					registerUnitCode: '',
					registerProject: '',
					registerTime: '',
					validityTime: '',
					rylx: '',
					csnx: '',
					isGcsysb: '',
					isGlzd: ''
				},
				rules: {
					personName: [{ required: true, trigger: 'change', message: '请选择人员' }],
					idCard: [{ required: true, trigger: 'change', message: '请选择人员' }],
					certificateName: [{ required: true, trigger: 'change', message: '请选择人员' }],
					certificateCode: [{ required: true, trigger: 'change', message: '请选择人员' }],
					validityTime: [{ required: true, trigger: 'change', message: '请选择人员' }],
					csnx: [{ required: true, trigger: 'blur', message: '请输入' }],
					isGlzd: [{ required: true, trigger: 'change', message: '请选择' }],
					isGcsysb: [{ required: true, trigger: 'change', message: '请选择' }]
				},

				// 人员库弹窗
				staffLibraryVisible: false,
				// 材料保存loading
				saveLoading: false
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {},
		created() {},
		mounted() {
			// 获取诊断记录对应的记录id
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			// 已绑定企业，并且成为了vip或者svip
			if (this.isHasCompany && (this.isVip || this.isSVip)) {
				this.handleQueryEngineeringMaintenanceInfo()
			}
		},
		methods: {
			// 查询工程监理维护的资质诊断材料
			handleQueryEngineeringMaintenanceInfo() {
				let params = {
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}
				queryGcjlMaterialRecord(params).then(response => {
					const { data } = response
					const { gcJlRy, materialRecord } = data
					// 人员信息
					if (gcJlRy) {
						// 表字段转换
						this.maintenanceForm.id = gcJlRy.id
						this.maintenanceForm.personId = gcJlRy.personId
						this.maintenanceForm.personName = gcJlRy.name
						this.maintenanceForm.certType = gcJlRy.certType
						this.maintenanceForm.sex = gcJlRy.sex
						this.maintenanceForm.idCard = gcJlRy.sfzh
						this.maintenanceForm.registerType = gcJlRy.registerType
						this.maintenanceForm.registerSubType = gcJlRy.registerSubType
						this.maintenanceForm.certificateName = gcJlRy.certificateName
						this.maintenanceForm.certificateGrade = gcJlRy.certificateGrade
						this.maintenanceForm.certificateCode = gcJlRy.zsbh
						this.maintenanceForm.certificateType = gcJlRy.certificateType
						this.maintenanceForm.registerCode = gcJlRy.registerUnitName
						this.maintenanceForm.registerUnitName = gcJlRy.registerUnitName
						this.maintenanceForm.registerUnitCode = gcJlRy.registerCode
						this.maintenanceForm.registerProject = gcJlRy.registerProject
						this.maintenanceForm.registerTime = gcJlRy.registerTime
						this.maintenanceForm.validityTime = gcJlRy.yxqjssj
						this.maintenanceForm.rylx = gcJlRy.rylx
						this.maintenanceForm.csnx = gcJlRy.csnx
					}

					// 其他信息
					if (materialRecord) {
						this.maintenanceForm.isGcsysb = materialRecord.isGcsb
						this.maintenanceForm.isGlzd = materialRecord.isGlzd
					}
				})
			},

			// 打开人员选择弹窗
			handleAddPerson() {
				this.staffLibraryVisible = true
			},

			// 回填选择的人员
			handleSaveStaffInfo() {
				console.log('staffIdArray:', this.$refs.supervisorLibrary.staffIdArray)
				const selectPersons = this.$refs.supervisorLibrary.staffIdArray
				if (selectPersons.length === 0) {
					this.$modal.msgWarning('请选择人员')
					return
				}

				// 转换对应字段
				const {
					id,
					personName,
					certType,
					sex,
					idCard,
					registerType,
					registerSubType,
					certificateName,
					certificateGrade,
					certificateCode,
					certificateType,
					registerCode,
					registerUnitName,
					registerUnitCode,
					registerProject,
					registerTime,
					validityTime,
					rylx,
					csnx,
					makeUnit
				} = selectPersons[0]
				this.maintenanceForm.personId = id
				this.maintenanceForm.personName = personName
				this.maintenanceForm.certType = certType
				this.maintenanceForm.sex = sex
				this.maintenanceForm.idCard = idCard
				this.maintenanceForm.registerType = registerType
				this.maintenanceForm.registerSubType = registerSubType
				this.maintenanceForm.certificateName = certificateName
				this.maintenanceForm.certificateGrade = certificateGrade
				this.maintenanceForm.certificateCode = certificateCode
				this.maintenanceForm.certificateType = certificateType
				this.maintenanceForm.registerCode = registerCode
				this.maintenanceForm.registerUnitName = registerUnitName
				this.maintenanceForm.registerUnitCode = registerUnitCode
				this.maintenanceForm.registerProject = registerProject
				this.maintenanceForm.registerTime = registerTime
				this.maintenanceForm.validityTime = validityTime
				this.maintenanceForm.rylx = rylx
				this.maintenanceForm.csnx = csnx
				this.maintenanceForm.makeUnit = makeUnit

				this.staffLibraryVisible = false
			},

			// 关闭材料维护
			handleCloseStaff() {
				this.staffLibraryVisible = false
			},

			// 保存监理资质诊断材料维护信息
			handleSaveEngineeringMaintenanceInfo() {
				this.$refs.maintenanceForm.validate(valid => {
					if (valid) {
						this.saveLoading = true

						const data = {
							...this.maintenanceForm,
							// 工程监理维护企业技术负责人员时固定传值
							isJsfzr: '1'
						}

						saveGcjlMaintenanceInfo(data)
							.then(response => {
								this.$modal.msgSuccess('保存成功')
								this.saveLoading = false
								this.handleQueryEngineeringMaintenanceInfo()
							})
							.catch(error => {
								this.saveLoading = false
							})
					}
				})
			},

			// 诊断材料提交处材料信息保存
			saveMaintenanceInfoPromise() {
				return new Promise((resolve, reject) => {
					this.$refs.maintenanceForm.validate(valid => {
						if (valid) {
							const data = {
								...this.maintenanceForm
							}

							saveGcjlMaintenanceInfo(data)
								.then(response => {
									resolve()
								})
								.catch(error => {
									reject()
								})
						} else {
							reject()
						}
					})
				})
			},

			// 验证资质诊断材料是否维护
			handleValidMaintenanceInfoIsSetting() {
				// 从 rules 对象中提取所有必填字段
				const requiredFields = Object.entries(this.rules)
					.filter(([field, validators]) => validators.some(v => v.required === true))
					.map(([field]) => field)

				console.log('requiredFields:', requiredFields)

				// 检查所有必填字段是否有值
				return requiredFields.every(field => {
					const value = this.maintenanceForm[field]
					return value !== undefined && value !== null && value !== ''
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.maintenance {
		// padding: 20px;

		.maintenance-container {
			background-color: #fff;
			border-radius: 4px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			position: relative;

			.maintenance-content {
				// display: flex;
				min-height: 600px;
				padding: 20px;

				.section-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 15px;
					position: relative;

					h4 {
						margin: 0;
						font-size: 16px;
						font-weight: 500;
						color: #333;
						display: flex;
						justify-content: flex-start;

						&::before {
							content: '';
							display: block;
							width: 4px;
							margin-right: 10px;
							background: #2671cb;
						}
					}
				}
			}

			.maintenance-footer {
				text-align: center;
				padding-bottom: 20px;

				.el-button--primary {
					width: 100px;
				}
			}
		}
	}

	.form-content {
		.form-row {
			display: flex;
		}
		.form-item {
			flex: 1;
			margin-bottom: 20px;
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
			}
		}
	}
</style>
